"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var OnlineIndicator = function () { return (react_1.jsx("div", { css: {
        width: '100%',
        height: '100%',
        backgroundColor: '#12B76A',
        borderRadius: '100%',
    } })); };
exports.default = OnlineIndicator;
